export const buildGroupSessionHref = (
  groupId: string,
  sessionId: number,
  fromAnalysis?: string
) => {
  const path = `/sessions/group/${groupId}/sessions/${sessionId}`;
  if (!fromAnalysis) {
    return path;
  }

  const params = new URLSearchParams({ fromAnalysis });
  return `${path}?${params.toString()}`;
};

export const buildGroupDetailHref = (
  groupId: string,
  fromAnalysis?: string | null
) => {
  const path = `/sessions/group/${groupId}`;
  if (!fromAnalysis) {
    return path;
  }

  const params = new URLSearchParams({ fromAnalysis });
  return `${path}?${params.toString()}`;
};

export const buildSpectralAnalysisHref = (analysisId: string) =>
  `/research/spectral-normalization/${analysisId}`;
